var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.article)?_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" "+_vm._s(_vm.article.title)+" ")]),_c('v-card-subtitle',{attrs:{"primary-title":""}},[_vm._v(" "+_vm._s(_vm.article.subtitle)+" ")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.article.content)}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }